import { Text } from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { View } from "@/components/ui/view";
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { CameraView } from 'expo-camera';
import i18n from 'i18n-js';
import * as MediaSelector from '../components/media/MediaSelector'
import { backendLogin } from '../stores/thunks';
import { Platform } from "react-native";

export default function QRCodeLogin({ navigation }) {
    const [scanned, setScanned] = useState(null);
    const dispatch = useDispatch()

    useEffect(() => {
        MediaSelector.requestPermissions()
        MediaSelector.ensureDirExists()
    }, [])

    const handleBarCodeScanned = ({ type, data }) => {
      console.log("scanned!")
        setScanned(true)
        // multiple types of QR code tags are in use created mostly from ids_1000_100000_safe_laser.csv
        //         line        date    # comment
        //     1 -   100 2022/12/22  100 internally used tags from inacoach_ids_1_100_unsafe.csv
        //     1 -   150 2022/08/01  150 tags with a 26 character Id
        //  2500 -  2999 2022/09/01  500 tags with a 26 character Id
        //  3000 -  4999            4999 unused tags with a 26 character Id
        //  5000 -  5599 2022/12/06  600 unused? tags
        //  5600 -  6999 2023/01/26 1400 tags with '§' replaced by '%', which where produced with CRFL appended: 28 characters, on android only an initial xFE byte is reported as well: 29 characters
        //  7000 -  7099 2024/08/16  100 tags with '§' encoded as 'Â§': 27 or 29 characters
        //  7100 -  7499 2024/08/16  400 tags with '§' replaced by '%' 26 characters
        const inLen = data.length
        console.log('QR IN', type, '<' + data + '>', inLen)
        // the § sign is encoded as Â§ C2A7 instead of A7
        data = data.replace(/Â§/g, '§')
        if (data.length != inLen) {
            console.log('QR Â§', '<' + data + '>', data.length)
        }
        if (data.length == 29) {
            // some codes scanned on Android get prefixed be hex FE
            data = data.substring(1)
            console.log('QR FE', '<' + data + '>', data.length)
        }
        navigation.goBack()
        dispatch(backendLogin('LOGIN', data))
    }
    const actionBack = () => {
        navigation.goBack()
    }

    return (
        <View className="bg-secondary-50 flex-1">
            <CameraView
                style={{ flex: 1, aspectRatio: 1 }}
                barcodeScannerSettings={{
                  barcodeTypes: ["qr"],
                }}
                onBarcodeScanned={scanned ? undefined : handleBarCodeScanned}
            />
            <Button variant='solid' onPress={actionBack} className={` bottom-${Platform.select({ android: 0, ios: 40 })} w-[90%] self-center absolute bg-secondary-50 active:bg-secondary-900 border-primary-900 m-2`}>
                <Text className="text-lg text-primary-900">{i18n.t('login.cancel')}</Text>
            </Button>
        </View>
    );
}
